import { Component } from '@angular/core';
import { Hero } from './hero/hero';
import { Problema } from './problema/problema';
import { Claims } from './claims/claims';
import { ParaQuien } from './para-quien/para-quien';
import { Funcionalidades } from './funcionalidades/funcionalidades';
import { Confianza } from './confianza/confianza';
import { Faq } from './faq/faq';
import { Interes } from './interes/interes';

@Component({
  selector: 'app-home',
  imports: [Hero, Problema, Claims, ParaQuien, Funcionalidades, Confianza, Faq, Interes],
  templateUrl: './home.html',
  styleUrl: './home.scss',
})
export class Home {}
